export default __webpack_public_path__ + "static/media/pageNotFound.c1303397.svg";